import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "coral-grey3-color fs-small pt-1 pl-1"
}

import { IonTextarea } from "@ionic/vue";
import { useField } from "vee-validate";

import { BaseTextareaProps } from "@/types/props";
import { TextareaBaseEmits } from "@/types/emits";


export default /*@__PURE__*/_defineComponent({
  __name: 'TextareaSimple',
  props: {
    autoGrow: { type: Boolean },
    modelValue: {},
    autocapitalize: {},
    autofocus: { type: Boolean },
    clearOnEdit: { type: Boolean },
    color: {},
    textareaClass: {},
    cols: {},
    debounce: {},
    disabled: { type: Boolean },
    enterkeyhint: {},
    inputmode: {},
    maxlength: {},
    minlength: {},
    mode: {},
    name: {},
    placeholder: {},
    readonly: { type: Boolean },
    required: { type: Boolean },
    rows: { default: 4 },
    spellcheck: { type: Boolean },
    wrap: {},
    validateOption: {}
  },
  emits: ["change", "blur", "focus", "update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

// Vee-Validate Composable
const {
    errors,
    handleChange,
    handleBlur,
    validate
} = useField(
    props.validateOption?.name ?? '',
    props.validateOption?.rules ?? '',
    {
        valueProp: props.modelValue,
        initialValue: JSON.parse(JSON.stringify(props.modelValue ?? '')),
        label: props.validateOption?.label ?? props.validateOption?.name,
        ...props.validateOption?.options ?? {}
    }
)

window.addEventListener('change-language', () => validate({ mode: 'force' }))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonTextarea), {
      value: __props.modelValue,
      "auto-grow": props.autoGrow,
      autocapitalize: props.autocapitalize,
      autofocus: props.autofocus,
      "clear-on-edit": props.clearOnEdit,
      color: props.color,
      class: _normalizeClass(["textarea-simple light-grey4-background purple-purple-color", __props.textareaClass]),
      cols: props.cols,
      debounce: props.debounce,
      disabled: props.disabled,
      enterkeyhint: props.enterkeyhint,
      inputmode: props.inputmode,
      maxlenght: props.maxlength,
      minlength: props.minlength,
      mode: props.mode,
      name: props.name,
      placeholder: props.placeholder,
      readonly: props.readonly,
      required: props.required,
      rows: props.rows,
      spellcheck: props.spellcheck,
      wrap: props.wrap,
      onIonInput: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$emit('update:modelValue', $event.target.value); _unref(handleChange)($event);}),
      onIonBlur: _cache[1] || (_cache[1] = ($event: any) => {_unref(handleBlur)($event); emit('blur', $event)}),
      onIonChange: _cache[2] || (_cache[2] = ($event: any) => (emit('change', $event))),
      onIonFocus: _cache[3] || (_cache[3] = ($event: any) => (emit('focus', $event)))
    }, null, 8, ["value", "auto-grow", "autocapitalize", "autofocus", "clear-on-edit", "color", "class", "cols", "debounce", "disabled", "enterkeyhint", "inputmode", "maxlenght", "minlength", "mode", "name", "placeholder", "readonly", "required", "rows", "spellcheck", "wrap"]),
    (_unref(errors).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(errors)[0]), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})